<template>
    <div role="tablist" class="tab-list" v-if="activeTabIndex !== null">
        <div class="scroller">
            <button
                @click="$emit('tab-click', index)"
                v-for="(tab, index) in tabs"
                :key="index"
                class="btn-tab"
                role="tab"
                :aria-selected="activeTabIndex === index"
                :aria-controls="tab.tabPanelId"
                :id="tab.tabId"
                :tabindex="activeTabIndex === index ? 0 : -1"
            >
                <span>{{ tab.tabLabel }}</span>
            </button>
        </div>
    </div>
</template>
<script>
export default {
    name: "GlobalSearchTabList",
    props: {
        tabs: {
            type: Array,
            default: () => []
        },
        activeTabIndex: {
            type: Number,
            default: null
        }
    }
};
</script>

<style lang="scss" scoped>
$vet-text-subtlest: #626f86;
$vet-text-green: #527a22;
$vet-border: #091e4224;
$vet-border-focused: #388bff;

.tab-list {
    position: relative;
    margin-left: -8px;

    &::before {
        content: "";
        position: absolute;
        height: 2px;
        background: $vet-border;
        inset: auto 0 0 8px;
    }
}

.scroller {
    display: flex;
    height: 34px;
    overflow-y: scroll;
}

.btn-tab {
    position: relative;
    white-space: nowrap;
    padding: 6px 8px;
    border: 0;
    outline: 0;
    background: transparent;

    span {
        font-weight: 500;
    }

    &:focus-visible {
        outline: 2px solid $vet-border-focused;
        outline-offset: -2px;
    }

    &:hover::after {
        content: "";
        position: absolute;
        inset: auto 8px 0;
        border-bottom: 2px solid #091e4224;
        border-radius: 2px;
    }

    &[aria-selected="true"] {
        color: $vet-text-green;

        &::after {
            content: "";
            position: absolute;
            inset: auto 8px 0;
            border-bottom: 2px solid $vet-text-green;
            border-radius: 2px;
        }
    }
}

@media screen and (min-width: 1200px) {
    .btn-tab {
        text-overflow: ellipsis;
        overflow-y: hidden;
    }
}
</style>
